// extracted by mini-css-extract-plugin
module.exports = {"divider":"WorkbenchPage_divider","root":"WorkbenchPage_root","panel":"WorkbenchPage_panel"};